export const useWithdrawalStore = () => {
    const init = () => {
        window.Alpine.store("withdrawal", {
            available: [],
            selected: null,
        });

        window.addEventListener('withdrawalRequestCanceled', event => {
            const withdrawalAmount = event.detail.amount;
            const currentBalance = window.Alpine.store('balance').value;
            const currentCashBalance = window.Alpine.store('cash_balance').value;

            window.Alpine.store('balance').value = currentBalance + withdrawalAmount;
            window.Alpine.store('cash_balance').value = currentCashBalance + withdrawalAmount;
        });
    };

    return { init };
};
